import { render, staticRenderFns } from "./ResourcePlanning.vue?vue&type=template&id=2df9f175&scoped=true"
import script from "./ResourcePlanning.vue?vue&type=script&lang=ts"
export * from "./ResourcePlanning.vue?vue&type=script&lang=ts"
import style0 from "./ResourcePlanning.vue?vue&type=style&index=0&id=2df9f175&prod&lang=scss&scoped=true"
import style1 from "./ResourcePlanning.vue?vue&type=style&index=1&id=2df9f175&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_css-loader@6.11.0_webpack@5.75.0__ejs@3.1.1_86e7ef74e9a65372c82132bf43ab6510/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df9f175",
  null
  
)

export default component.exports